import { ActiveModel } from '../active-model';
import { ModelCurrentTaskIncidenceTotals } from './model-current-task-incidence-totals';
import { ModelCurrentTaskPiecesTime } from './model-current-task-pieces-time';
import { ModelSummaryOee } from './model-summary-oee';
import { ModelSummaryProgram } from './model-summary-program';
import { ModelSummaryStatus } from './model-summary-status';
import { ModelSummaryTime } from './model-summary-time';

export class ModelSummary {
  constructor(
    public model?: ActiveModel,
    public status?: ModelSummaryStatus,
    public program?: ModelSummaryProgram,
    public schedulerTaskTimes?: ModelSummaryTime,
    public schedulerTaskTimesTrend?: ModelSummaryTime,
    public daily?: ModelSummaryTime,
    public week?: ModelSummaryTime,
    public oee?: ModelSummaryOee,
    public totals?: ModelCurrentTaskIncidenceTotals,
    public piecesTime?: ModelCurrentTaskPiecesTime,
    public schedulerTaskHash?: string,
  ) { }

  get modelOrder() {
    return (this.model) ? this.model.order : 0;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary.ts